export const headers = [
  { name: 'Tipo', field: 'type', sortable: true, custom: true },
  { name: 'Título', field: 'title', sortable: true },
  { name: 'Data inicial', field: 'start_date', sortable: true },
  { name: 'Data final', field: 'end_date', sortable: false },
  { name: 'Cadastrado em', field: 'created_at', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
